export default __webpack_public_path__ + "static/media/nanny1.a3a58f08.jpg";